const MONTH_ABBR = ['Jan','Feb','Mar','Apr','May','Jun',
                    'Jul','Aug','Sep','Oct','Nov','Dec'];

// Display a backend date as DD/MM/YYYY.
// Accepts "2026-07-29", "2026-07-29T00:00:00.000Z", "2026-07-29 10:30:00", and
// the raw JS date string "Wed Jul 29 2026 00:00:00 GMT-0400 (Eastern Daylight Time)".
// Reads the date parts textually - never constructs a Date, so the day can never
// shift by a timezone offset and the timezone name is never shown to the user.
export const formatDate = (value) => {
    if (value === null || value === undefined) return '';
    const text = String(value);

    const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
        const [, year, month, day] = iso;
        return `${day}/${month}/${year}`;
    }

    // "Wed Jul 29 2026 ..." - what String(new Date()) produces on the server.
    const js = text.match(/^[A-Za-z]{3} ([A-Za-z]{3}) (\d{2}) (\d{4})/);
    if (js) {
        const [, abbr, day, year] = js;
        const index = MONTH_ABBR.indexOf(abbr);
        if (index !== -1) return `${day}/${String(index + 1).padStart(2, '0')}/${year}`;
    }

    return text;                               // unrecognised - show as-is, never blank
};

// Normalise a backend date for an <input type="date">, which only accepts YYYY-MM-DD.
// Handles the same input shapes as formatDate; returns '' when there is no date to show.
export const toInputDate = (value) => {
    if (value === null || value === undefined) return '';
    const text = String(value);

    const iso = text.match(/^\d{4}-\d{2}-\d{2}/);
    if (iso) return iso[0];

    const js = text.match(/^[A-Za-z]{3} ([A-Za-z]{3}) (\d{2}) (\d{4})/);
    if (js) {
        const [, abbr, day, year] = js;
        const index = MONTH_ABBR.indexOf(abbr);
        if (index !== -1) return `${year}-${String(index + 1).padStart(2, '0')}-${day}`;
    }

    return '';
};

const MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];

// Month number (1-12, string or number) -> month name. '' when out of range.
export const monthName = (value) => MONTHS[parseInt(value, 10) - 1] || '';
